import * as React from 'react'
import { memo } from 'react'

const SvgGolf = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 13.539 20"
  >
    <path d="M13.286 4.245 6.047.068a.5.5 0 0 0-.756.436v13.905C2.572 14.598 0 15.558 0 17.181 0 19.013 3.243 20 6.3 20s6.3-.988 6.3-2.819-3.253-2.8-6.3-2.807V9.151l6.987-4.031a.5.5 0 0 0 0-.874Zm-1.725 12.946c0 .756-2.016 1.812-5.291 1.812S.979 17.947.979 17.191c0-.675 1.613-1.587 4.283-1.764v1.633a.504.504 0 0 0 1.008 0v-1.692c3.288.012 5.291 1.066 5.291 1.819Zm-5.266-9.2V1.378l5.727 3.306Z" />
  </svg>
)

const Memo = memo(SvgGolf)
export default Memo
